

export function supportsWebCodecs() {
    try {
        return !!(
            self.VideoDecoder &&
            self.AudioDecoder &&
            self.VideoFrame
        );
    } catch {
        return false;
    }
}

/**
 * Helper to check if the platform is iOS
 */
export const isIos = (): boolean => {
    let ua = window.navigator.userAgent ?? "";
    return !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
}

/**
 * Helper to check if the platform is Android
 */
export const isAndroidMobile = (): boolean => {
    const ua = navigator.userAgent ?? "";

    // Android devices report "Android" in UA; most will also have "Mobile"
    // (tablets sometimes omit "Mobile")
    const isAndroid = /Android/i.test(ua);
    const isMobileHint = /Mobile/i.test(ua);

    return isAndroid && isMobileHint;
}

export function isMobile(): boolean {
    return isIos() || isAndroidMobile();
}
